import { useMemo } from 'react';
import { Grid } from '@mui/material';

import { Select } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
import { useConfig } from '@occc/config';

// "Universal" (no sub brand) is represented by an empty uuid.
export const UNIVERSAL_SUB_BRAND_OPTION = { label: 'Universal', value: '' };

export const SUB_BRAND_FIELD_NAME = 'subBrand.uuid';

export const SubBrandSelector = () => {
  const { config } = useConfig();

  const subBrandOptions = useMemo(
    () => [
      UNIVERSAL_SUB_BRAND_OPTION,
      ...(config.subBrands?.list ?? []).map((subBrand) => ({
        label: subBrand.name,
        value: subBrand.uuid,
      })),
    ],
    [config.subBrands?.list],
  );

  return (
    <>
      <Typography variant='h6' paragraph>
        Target Members in this Sub Brand
      </Typography>
      <Grid container>
        <Grid item xs={12} md={3}>
          <Select
            name={SUB_BRAND_FIELD_NAME}
            label='Select a Sub Brand'
            data={subBrandOptions}
            displayEmpty
            inputLabelProps={{ shrink: true }}
            formControlProps={{ margin: 'none' }}
          />
        </Grid>
      </Grid>
    </>
  );
};
